<script lang="ts">
	import { IconButton } from '@shared/svelte';
</script>

<div class="mv-app-bar-nav-button">
	<IconButton icon="menu" iconColor="neutral-700" on:click />
</div>
